<template>
  <vue-final-modal v-model="medleyLinkModalVisible" name="medley-link-dialog"
    :classes="['medley-link-dialog__container']"
    :styles="{ display: 'flex', alignItems: 'center', justifyContent: 'center' }"
    :content-class="['medley-link-dialog__content', 'v--modal-box', 'v--modal']"
    :click-to-close="true" :lock-scroll="true"
    @opened="onMedleyLinkModalOpened" @closed="onMedleyLinkModalClosed"
    @before-close="handleBeforeClose">
    <div style="text-align: left;">
      <p style="color: gray; border: 1px solid; display: inline;">PR</p>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeMedleyLinkDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 1rem; font-weight: bold;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">さっそく転職活動をスタートしましょう！<br>好条件求人満載のおすすめサイトはここ！</p>
        <div style="text-align:center; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="sendMedleyConsult()">
          <p style="display: inline-block;">
            <img :src="dialogInfo.logoImage" alt="">
          </p>
        </div>
        <p style="font-weight: bold;"><span style="color:red;">【重要】</span>ご同意頂いた方に、{{ dialogInfo.clientServiceName }}より<br>ご案内のメールを送付しますので、ご確認下さい。
        </p>
        <br>
        <p style="font-size: 80%;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          {{ dialogInfo.clientName }}の<a :href="dialogInfo.termurl" target="_blank">利用規約</a>、<a
            :href="dialogInfo.privacyurl" target="_blank">個人情報保護方針</a>を
          <br>確認して{{ dialogInfo.clientServiceName }}に登録することになります。
        </p>
        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;">
          <el-checkbox v-model="isAgree"
            style="-moz-transform:scale(1.4);-webkit-transform:scale(1.4);transform:scale(1.4);">各種規約に同意して無料登録する</el-checkbox>
        </p>
        <div class="text-center" style="padding:10px">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="!isSendedMedley"
            style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;"
            @click="sendMedleyConsult()">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-else
            style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMedleyLinkDialog()">送信しました</el-button>
          <br />
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script setup lang="ts">
import { ref, computed, inject, onBeforeMount, onUnmounted, nextTick, getCurrentInstance } from 'vue'
import { emitRtDialogClosedWithoutSubmit } from '@/plugins/emitter'
import { useRealtimeTransferSend, RtSendFactoryKey } from '@/composables/useRealtimeTransferSend'

const vm = getCurrentInstance()!.proxy as any

const isMypage = ref(false)
const formatid = ref('')
const previewHtml = ref('')
const permissionType = ref(5)
const isSendedMedley = ref(false)
const fullscreenLoading = ref(false)
const clientId = ref('medley_link')
const dialogName = ref('medley_dialog')
const username = ref('')
const isAgree = ref(true)
const basicData = ref<Record<string, any>>({})
const dialogInfo = ref<Record<string, any>>({})
const medleyLinkModalVisible = ref(false)
const medleyLinkModalOpened = ref(false)
const pendingReshow = ref(false)
const replacingOpen = ref(false)

const pdfFormData = computed(() => {
  const fd = new FormData()
  fd.append('app_html', previewHtml.value)
  fd.append('pdf_option', 'A4')
  return fd
})

function createFilename (ext: string): string {
  const now = new Date()
  const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX ?? ''
  const dateString = vm.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
  return `${prefix}${formatid.value}${dateString}.${ext}`
}

function getPrefName (): string { return '' }
function getCityName (): string { return '' }

function openMedleyLinkDialog (id: string, html: any, perm: number, info: Record<string, any>, bd: Record<string, any>, mypage = false) {
  isMypage.value = mypage
  formatid.value = id
  previewHtml.value = html && html.$el ? html.$el.innerHTML : ''
  permissionType.value = perm
  dialogInfo.value = info
  basicData.value = bd || {}
  clientId.value = info.clientId ?? 'medley_link'
  dialogName.value = info.dialogName ?? 'medley_dialog'
  isSendedMedley.value = false
  isAgree.value = true

  const formData = new FormData()
  formData.append('uuid', vm.$firebase.user.uid)
  formData.append('format_id', formatid.value)
  formData.append('dialog_name', dialogName.value)
  formData.append('permission_type', String(permissionType.value))
  formData.append('device_flg', vm.$deviceLib.isMobileDevice ? 'SP' : 'PC')
  formData.append('version', '2')
  formData.append('is_mypage', isMypage.value ? 'true' : 'false')
  formData.append('site_flag', 'r')
  formData.append('app_flag', vm.$site.appFlag)
  vm.$axios.post(vm.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })

  vm.$iterateStorage((value: any, key: string) => {
    if (key === 'basicData') username.value = `${value.lastName}_${value.firstName}`
  }, (err: any) => { if (!err) console.log('Iteration has completed') })

  if (medleyLinkModalOpened.value) {
    pendingReshow.value = true
    replacingOpen.value = true
    medleyLinkModalVisible.value = false
  } else {
    nextTick(() => { medleyLinkModalVisible.value = true })
  }
}

function onMedleyLinkModalOpened () { medleyLinkModalOpened.value = true }

function onMedleyLinkModalClosed () {
  medleyLinkModalOpened.value = false
  if (pendingReshow.value) {
    pendingReshow.value = false
    replacingOpen.value = false
    nextTick(() => { medleyLinkModalVisible.value = true })
  }
}

function closeMedleyLinkDialog () { medleyLinkModalVisible.value = false }

function handleBeforeClose () {
  if (replacingOpen.value) return
  if (!isSendedMedley.value) {
    vm.$eventHub.$emit('update_rt_condition', clientId.value, permissionType.value)
    emitRtDialogClosedWithoutSubmit()
  }
}

const rtSendFactory = inject(RtSendFactoryKey, useRealtimeTransferSend)
const { sendMedleyConsult } = rtSendFactory({
  vm,
  isAgree,
  isRealtimeTransferCommonSended: isSendedMedley,
  fullscreenLoading,
  pdfFormData,
  formatid,
  username,
  clientId,
  dialogName,
  permissionType,
  basicData,
  dialogInfo,
  isMypage,
  createFilename,
  getPrefName,
  getCityName
})

vm.$iterateStorage((value: any, key: string) => {
  if (key === 'basicData') username.value = `${value.lastName}_${value.firstName}`
}, (err: any) => { if (!err) console.log('Iteration has completed') })

let mittGVPopupHandler: ((argList: unknown) => void) | undefined

onBeforeMount(() => {
  mittGVPopupHandler = (argList: unknown) => {
    if (Array.isArray(argList)) openMedleyLinkDialog.apply(null, argList as any)
  }
  vm.$emitter.on('open-medleylink-dialog', mittGVPopupHandler)
  vm.$emitter.on('send-medleylink-consult', sendMedleyConsult)
  vm.$eventHub.$on('popstate', closeMedleyLinkDialog)
})

onUnmounted(() => {
  vm.$emitter.off('open-medleylink-dialog', mittGVPopupHandler)
  vm.$emitter.off('send-medleylink-consult', sendMedleyConsult)
  vm.$eventHub.$off('popstate', closeMedleyLinkDialog)
})
</script>

<style scoped lang="scss">
/* content-class は VueFinalModal 内部のノードのため scoped だけだと [data-v-*] が付かない → :deep() で子まで適用 */
:deep(.medley-link-dialog__container) {
  box-sizing: border-box;
  align-items: flex-start !important;
  overflow-y: auto;
  padding: 40px 0;
  -webkit-overflow-scrolling: touch;
}

:deep(.medley-link-dialog__content) {
  background: #fff;
  box-sizing: border-box;
  flex: 0 1 auto;
  align-self: center;
  width: 600px;
  max-width: 100%;
  height: auto;
  margin-top: auto;
  margin-bottom: auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: visible;
}
</style>
